import styled from 'styled-components';
import { Base, Theme } from 'styled';
import { Color } from 'styled/theme/colors';

type ContainerProps = {
  applyArticleBodyWidthOffset: boolean | undefined;
};

type CardProps = {
  textColor: Color;
  bgColor: Color;
};

export const Container = styled(Base)<ContainerProps>`
  ${({ theme, applyArticleBodyWidthOffset }) =>
    applyArticleBodyWidthOffset && theme.global.articleInnerTextFullWidth};
`;

export const Header = styled(Base)`
  ${({ theme }) => theme.global.moduleContentPaddingX};
`;

export const Carousel = styled(Base)`
  /* Override NukaCarousel */
  .slider-slide {
    pointer-events: all;
    cursor: grab;

    :active {
      cursor: grabbing;
    }
  }
`;

export const CardContainer = styled(Base)`
  display: flex;
  align-items: stretch;
  min-height: 100%;
`;

export const Card = styled(Base)<CardProps>`
  background-color: ${({ bgColor, theme }) => theme.colors[bgColor]};
  color: ${({ textColor, theme }) => theme.colors[textColor]};
  min-width: 20.375rem;
  width: 20.375rem;
  min-height: 29rem;

  ${Theme.mediaQueries.md} {
    min-width: 28.875rem;
    width: 28.875rem;
    min-height: 36.875rem;
  }
`;

export const ControlArrow = styled(Base)``;

/*
 * Shared components
 */

export const ItemContainer = styled(Base)`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
  height: 100%;
`;

export const ContentHubItemImage = styled(Base)`
  object-fit: contain;
  width: 100%;
  height: 100%;
  max-width: 100%;
  max-height: 9.1875rem;

  ${Theme.mediaQueries.md} {
    max-height: 11.19875rem;
  }
`;
